import React, { useState } from 'react';
import clsx from 'clsx';
import { withRouter } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import MuiCollapse from '@material-ui/core/Collapse';
import MuiDivider from '@material-ui/core/Divider';
import MuiDrawer from '@material-ui/core/Drawer';
import MuiList from '@material-ui/core/List';
import MuiListItem from '@material-ui/core/ListItem';
import MuiListItemText from '@material-ui/core/ListItemText';
import MuiHomeIcon from '@material-ui/icons/Home';
import MuiAttachMoneyIcon from '@material-ui/icons/AttachMoney';
import MuiLocalAtmIcon from '@material-ui/icons/LocalAtm';
import MuiPowerInputIcon from '@material-ui/icons/PowerInput';
import MuiCallSplit from '@material-ui/icons/CallSplit';
import MuiListItemIcon from '@material-ui/core/ListItemIcon';
import MuiPeopleIcon from '@material-ui/icons/People';
import MuiAlbumIcon from '@material-ui/icons/Album';
import MuiExpandLess from '@material-ui/icons/ExpandLess';
import MuiExpandMore from '@material-ui/icons/ExpandMore';
import MuiLibraryMusicIcon from '@material-ui/icons/LibraryMusic';
import MuiAutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import MembershipIcon from '@mui/icons-material/RememberMe';
import Handshake from '@mui/icons-material/Handshake';
import MuiEmailIcon from '@material-ui/icons/Email';
import MuiAnalyticsIcon from '@material-ui/icons/Assessment';
import MuiSearchIcon from '@material-ui/icons/Search';

const categories = [
  {
    id: 'Develop',
    children: [
      {
        id: 'home',
        label: 'Home',
        icon: <MuiHomeIcon />,
        route: '/',
      },
      {
        id: 'comanager',
        label: 'Co-Manager Training',
        icon: <MuiAutoAwesomeIcon />,
        route: '/comanager-documents',
      },
      {
        id: 'users_and_groups',
        label: 'Users & Groups',
        icon: <MuiPeopleIcon />,
        children: [
          {
            id: 'groups',
            label: 'Groups',
            icon: <MuiPeopleIcon />,
            route: '/groups',
          },
          {
            id: 'service-deals',
            label: 'Service Deals',
            route: '/service-deals',
            icon: <Handshake />,
          },
          {
            id: 'artists',
            label: 'Artists',
            route: '/artists',
            icon: <MuiAlbumIcon />,
          },
          {
            id: 'email_loolup',
            label: 'Lookup by Email',
            route: '/universal-lookup-by-email',
            icon: <MuiEmailIcon />,
          },
        ],
      },
      {
        id: 'dsps',
        label: 'DSPs',
        icon: <MuiPowerInputIcon />,
        route: '/dsps',
      },
      {
        id: 'releases',
        label: 'Releases',
        icon: <MuiLibraryMusicIcon />,
        children: [
          {
            id: 'releases',
            label: 'Manage Releases',
            icon: null,
            route: '/manage-releases',
          },
          {
            id: 'distribution-history',
            label: 'Distribution History',
            icon: null,
            route: '/distribution-history',
          },
          {
            id: 'distro-queue',
            label: 'Queue Dashboard',
            icon: null,
            route: `${process.env.REACT_APP_DATA_API_URL}/arena`,
          },
        ],
      },
      {
        id: 'splits',
        label: 'Splits',
        icon: <MuiCallSplit />,
        children: [
          {
            id: 'payees',
            label: 'Payees',
            icon: null,
            route: '/payees',
          },
          {
            id: 'track-splits',
            label: 'Track Splits',
            icon: null,
            route: '/track-splits',
          },
        ],
      },
      {
        id: 'finances',
        label: 'Financials',
        icon: <MuiAttachMoneyIcon />,
        children: [
          {
            id: 'report-files',
            label: 'Report Files',
            route: '/report-files',
            icon: null,
          },
          {
            id: 'report-invoices',
            label: 'Report Invoices',
            icon: null,
            route: '/report-invoices',
          },
          {
            id: 'track-revenues',
            label: 'Track Revenues',
            icon: null,
            route: '/track-revenues',
          },
          {
            id: 'royalty-transfers',
            label: 'Royalty Transfers',
            icon: null,
            route: '/royalty-transfers',
          },
          {
            id: 'recoupment-accounts',
            label: 'Recoupment Accounts',
            icon: null,
            route: '/recoupment-accounts',
          },
          {
            id: 'affiliate-payments',
            label: 'Affiliate Payments',
            icon: null,
            route: '/affiliate-payments',
          },
        ],
      },
      {
        id: 'platformFees',
        label: 'Platform Fees',
        icon: <MuiLocalAtmIcon />,
        children: [
          // {
          //   id: 'platform-fees-labels',
          //   label: 'By Label',
          //   icon: null,
          //   route: '/platform-fees/label',
          // },
          {
            id: 'platform-fees-release',
            label: 'By Release',
            icon: null,
            route: '/platform-fees/release',
          },
        ],
      },
      {
        id: 'memberships',
        label: 'Memberships',
        icon: <MembershipIcon />,
        children: [
          {
            id: 'membership-events',
            label: 'Events',
            route: '/membership-events',
            icon: null,
          },
          {
            id: 'membership-perks',
            label: 'Perks',
            route: '/membership-perks',
            icon: null,
          },
        ],
      },
      {
        id: 'linkfire-ingestion-history',
        label: 'Linkfire Ingestion History',
        route: '/linkfire-ingestion-history',
        icon: <MuiAnalyticsIcon />,
      },
      {
        id: 'query-library',
        label: 'Query Library',
        route: '/query-library',
        icon: <MuiSearchIcon />,
      },
    ],
  },
];

const styles = theme => ({
  categoryHeader: {
    backgroundColor: theme.palette.primary.main,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  categoryHeaderPrimary: {
    color: theme.palette.common.white,
  },
  item: {
    paddingTop: 1,
    paddingBottom: 1,
    color: 'rgba(255, 255, 255, 0.7)',
    '&:hover,&:focus': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
  },
  itemNested: {
    paddingLeft: theme.spacing(3.25),
  },
  itemCategory: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    boxShadow: '0 -1px 0 #404854 inset',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  overview: {
    fontSize: 24,
    color: theme.palette.common.white,
  },
  itemActiveItem: {
    color: theme.palette.secondary.main,
  },
  itemPrimary: {
    fontSize: 'inherit',
  },
  itemIcon: {
    minWidth: 'auto',
    marginRight: theme.spacing(1),
  },
  divider: {
    marginTop: theme.spacing(1),
  },
});

const NavSidebar = props => {
  const { classes, match, history, staticContext: _screwPK, ...rest } = props;
  const { url } = match;

  const [openItems, setOpenItems] = useState({
    releases: true,
    splits: true,
    finances: true,
    platformFees: true,
    memberships: true,
    users_and_groups: true,
  });

  const urlMatchesRoute = route => {
    if (route === '/') return url === route;

    return url.indexOf(route) !== -1;
  };

  const handleParentItemClick = id => {
    setOpenItems(prevState => ({ ...prevState, [id]: !prevState[id] }));
  };

  const handleListItemClick = route => {
    if (route.startsWith('http')) {
      window.location.href = route;
    }

    history.push(route);
  };

  return (
    <MuiDrawer variant="permanent" {...rest}>
      <MuiList disablePadding>
        {categories.map(({ id, children }) => (
          <React.Fragment key={id}>
            <MuiListItem className={classes.categoryHeader}>
              {/*
              <MuiListItemText
                classes={{
                  primary: classes.categoryHeaderPrimary,
                }}
              >
                {id}
              </MuiListItemText>
            */}
            </MuiListItem>
            {children.map(({ id, label, icon, route, children }) =>
              children ? (
                <React.Fragment key={id}>
                  <MuiListItem button className={classes.item} onClick={() => handleParentItemClick(id)}>
                    <MuiListItemIcon className={classes.itemIcon}>{icon}</MuiListItemIcon>
                    <MuiListItemText
                      classes={{
                        primary: classes.itemPrimary,
                      }}>
                      {label}
                    </MuiListItemText>
                    {openItems[id] ? <MuiExpandLess /> : <MuiExpandMore />}
                  </MuiListItem>
                  <MuiCollapse key={id} in={openItems[id]} timeout="auto" unmountOnExit>
                    <MuiList component="div">
                      {children.map(({ id, label, icon, route }) => (
                        <MuiListItem
                          key={id}
                          button
                          className={clsx(
                            classes.item,
                            classes.itemNested,
                            urlMatchesRoute(route) ? classes.itemActiveItem : ''
                          )}
                          onClick={() => handleListItemClick(route)}>
                          {icon && <MuiListItemIcon className={classes.itemIcon}>{icon}</MuiListItemIcon>}
                          <MuiListItemText
                            classes={{
                              primary: classes.itemPrimary,
                            }}>
                            {label}
                          </MuiListItemText>
                        </MuiListItem>
                      ))}
                    </MuiList>
                  </MuiCollapse>
                </React.Fragment>
              ) : (
                <MuiListItem
                  key={id}
                  button
                  className={clsx(classes.item, urlMatchesRoute(route) ? classes.itemActiveItem : '')}
                  onClick={() => handleListItemClick(route)}>
                  <MuiListItemIcon className={classes.itemIcon}>{icon}</MuiListItemIcon>
                  <MuiListItemText
                    classes={{
                      primary: classes.itemPrimary,
                    }}>
                    {label}
                  </MuiListItemText>
                </MuiListItem>
              )
            )}

            <MuiDivider className={classes.divider} />
          </React.Fragment>
        ))}
      </MuiList>
    </MuiDrawer>
  );
};

export default withStyles(styles)(withRouter(NavSidebar));
